module.exports = __webpack_public_path__ + "static/media/GWE Curriculum .6447a36c.pdf";